// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { Vector3, IVector3 } from "./System.Numerics.Vector3.gen";

export interface ITargetTrackPoint {
	date: string | undefined;

	position: IVector3 | undefined;

	rawPosition: IVector3 | undefined;

	$type?: string | undefined;
}
export class TargetTrackPoint {
	constructor(data?: ITargetTrackPoint) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.date) { this.date = new Date(data.date); }
		if (data.position) { this.position = new Vector3(data.position); }
		if (data.rawPosition) { this.rawPosition = new Vector3(data.rawPosition); }
	}

	date: Date | undefined = new Date();

	position: Vector3 | undefined;

	rawPosition: Vector3 | undefined;

	static $type: string = "CoreApi.Models.TargetTrackPoint, ";
	$type?: string | undefined = TargetTrackPoint.$type;
}

